"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFullAdRequestToJSON = exports.CreateFullAdRequestFromJSONTyped = exports.CreateFullAdRequestFromJSON = exports.instanceOfCreateFullAdRequest = void 0;
var runtime_1 = require("../runtime");
var CreateAdRequest_1 = require("./CreateAdRequest");
/**
 * Check if a given object implements the CreateFullAdRequest interface.
 */
function instanceOfCreateFullAdRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateFullAdRequest = instanceOfCreateFullAdRequest;
function CreateFullAdRequestFromJSON(json) {
    return CreateFullAdRequestFromJSONTyped(json, false);
}
exports.CreateFullAdRequestFromJSON = CreateFullAdRequestFromJSON;
function CreateFullAdRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createAdRequest': !(0, runtime_1.exists)(json, 'create_ad_request') ? undefined : (0, CreateAdRequest_1.CreateAdRequestFromJSON)(json['create_ad_request']),
    };
}
exports.CreateFullAdRequestFromJSONTyped = CreateFullAdRequestFromJSONTyped;
function CreateFullAdRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'create_ad_request': (0, CreateAdRequest_1.CreateAdRequestToJSON)(value.createAdRequest),
    };
}
exports.CreateFullAdRequestToJSON = CreateFullAdRequestToJSON;
